<div class="contenedor-form">
    <div class="row">
  
        <mat-card>
  
          <div class="row">
            <mat-tab-group (selectedTabChange)="tabClick($event)">
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">announcement</mat-icon>
                  Gestión Motivo
                </ng-template>
                <app-motivos></app-motivos>
              </mat-tab>
  
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">assignment_late</mat-icon>
                  Gestión Tipo Motivo
                </ng-template>
                <app-tipo-motivo></app-tipo-motivo>
              </mat-tab>
  
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">assessment</mat-icon>
                  Gestión Tipo Motivo Clas
                </ng-template>
                <app-tipo-motivo-clas></app-tipo-motivo-clas>
                <!--<app-consultar-persona></app-consultar-persona>-->
              </mat-tab>
  
              <!--<mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">search</mat-icon>
                  Consultar
                </ng-template>
                <app-consultar-menu></app-consultar-menu>
              </mat-tab>-->
  
  
            </mat-tab-group>
  
          </div>
  
  
        </mat-card>
  
  
  
    </div>
  </div>
  
  
  